import { motion } from "framer-motion";

export const LogoMark = ({ className = "h-10", draw = false }) => (
  <motion.img
    src="/img/logo-600.png"
    alt="Hair Boutique"
    initial={draw ? { opacity: 0, scale: 0.92, clipPath: "inset(0 100% 0 0)" } : false}
    animate={draw ? { opacity: 1, scale: 1, clipPath: "inset(0 0% 0 0)" } : undefined}
    transition={{ duration: 1.2, ease: [0.65, 0, 0.35, 1] }}
    className={`w-auto object-contain ${className}`}
  />
);

export const Logo = ({ testId }) => (
  <a href="#top" data-testid={testId} className="group flex items-center">
    <LogoMark className="h-9 sm:h-11 transition-transform duration-500 group-hover:-translate-y-0.5" />
  </a>
);
